const locale = {
    VehicleVIOReport: "Rapport VIO du véhicule",
    ArticleVIOReport: "Article Rapport VIO",
    History: "Histoire",
    UserManagement: "Gestion des utilisateurs"
}

export default locale;